export type GrantsfinanceBoilerType = {
  src: string;
  title: string;
  content: string;
};
export type GrantsfinanceSolarType = {
  src: string;
  title: string;
  content: string;
  list: string[];
};

export const GrantsBoiler: GrantsfinanceBoilerType[] = [
  {
    src: "images/checkout-success/logo-seai.webp",
    title: "Grants",
    content:
      "The Sustainable Energy Authority of Ireland are currently offering home owners grants of up to €750 for upgrading your property with heating controls."
  }
];
export const FinanceBoiler: GrantsfinanceBoilerType[] = [
  {
    src: "images/checkout-success/logo-hum.webp",
    title: "Finance",
    content:
      "Swyft Energy has teamed up with Humm so you can buy now and pay later. You have full control to your own humm account and you can pay out early with no additional fees."
  }
];

export const GrantsSolar: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-seai.webp",
    title: "Grants",
    content:
      "If you are eligible for the seai grant, we take the following steps to make sure your grant is submitted successfully.",
    list: [
      "We complete your NC6 form to qualify you for the feed-in-tariff.",
      "We guide you step-by-step through the grant application.",
      "We manage the application process, and liase with the SEAI on your behalf.",
      "Following your installation we organise your BER assessment.",
      "We gather all necessary documentation and submit your grant to the SEAI."
    ]
  }
];

export const GrantsSolarFarm: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-gov-ie.png",
    title: "TAMS Grants",
    content: "Farmers can now claim up to 60% of the cost of their Solar PV installation through the TAMS grant.",
    list: [
      "We will complete your ‘On Farm Solar PV Survey’ which is required for your TAMS Application.",
      "We will complete the farm layout required for your TAMS Application.",
      "The minimum amount to avail of this grant is €2,000 and the maximum is €90,000.",
      "The grant is available for self-consumption only."
    ]
  }
];

export const FinanceSolar: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-finance.webp",
    title: "Finance",
    content:
      "By partnering with Finance ireland, Swyft Energy customers can now avail of a hassle-free finance offering, with lending terms from 2-10 years, and covering all budgets with finance available from €4,000 to €25,000.",
    list: [
      "Full online application process",
      "Credit decision within 24 hours",
      "Competitive interest rate of 6.7%",
      "Option to borrow up to 10 years at the same rate",
      "20% in additional funds can be paid to the customer"
    ]
  }
];

export const FinanceSolarFarm: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-finance.webp",
    title: "Finance Ireland Fund Equip",
    content:
      "FundEquip is a low-cost term loan to help purchase Solar PV in the Dairy Industry for farmers who are customer’s of a participating Co-op.",
    list: [
      "Seasonal payments: April to November inclusive, to suit milk production",
      "Repayment deducted from monthly milk receipt",
      "Loan size: €3,000 - €75,000",
      "Loan term: 3 or 5 years only"
    ]
  }
];
